<template>
  <form @submit.prevent="registerUser" class="grid-container">

    <BaseInput
      type="text"
      label="First Name"
      name="first-name"
      v-model="firstName"
      class="mb-2"
    />
    <BaseInput
      type="phone"
      label="Last Name"
      name="last-name"
      v-model="lastName"
      class="mb-2"
    />
    <BaseInput
      type="email"
      label="Email"
      name="email"
      v-model="email"
      class="mb-2"
    />
    <BaseInput
      type="text"
      label="Phone"
      name="phone"
      v-model="phone"
      class="mb-2"
    />
    <BaseInput
      type="password"
      label="Password"
      name="password"
      v-model="password"
      class="mb-2"
    />
    <BaseInput
      type="password"
      label="Confirm Password"
      name="password-confirm"
      v-model="passwordConfirm"
      class="mb-4"
    />

    <div class="input-wrapper privacy">
        <span class="privacy"> 
            <label class="checkbox-container">
                <input type="checkbox" v-model="privacy" name="privacy" value="Agreed" id="privacy" required >
                <span class="checkmark"></span>    
            </label>
            <span>
            The personal information you provide will be used exclusively to process your request.
            <br>We won't share your information with third parties.
            <br>We will not disclose any information to other organisations unless we are required by law to do so or to prevent fraud.</span>
        </span>
    </div>
<!--     <span class="privacy"><p>
        The personal information you provide will be used exclusively to process your request.
        <br>We won't share your information with third parties.
        <br>We will not disclose any information to other organisations unless we are required by law to do so or to prevent fraud.</p>
        <br>By registering you agree with our <strong><router-link class="ninety-grey" to="/privacy-policy">Privacy</router-link> </strong> and  
               <strong><router-link class="ninety-grey" to="/cookie-policy">Cookie Policies</router-link></strong>
    </span> -->
    <br><br>
    
    
    <BaseBtn type="submit" text="Register" />
    
    <FlashMessage :message="message" :error="error" />
    
  </form>
</template>

<script>
import { getError } from "../utils/helpers";
import BaseBtn from "./BaseBtn";
import BaseInput from "./BaseInput";
import AuthService from "../services/AuthService";
import FlashMessage from "./FlashMessage";

export default {
  name: "RegisterForm",
  components: {
    BaseBtn,
    BaseInput,
    FlashMessage,
  },
  data() {
    return {
      privacy: [],
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      password: null,
      passwordConfirm: null,
      error: null,
      message: null,
    };
  },
  methods: {
    registerUser() {
      this.error = null;
      this.message = null;
      const payload = {
        privacy: this.privacy,
        first_name: this.firstName,
        last_name: this.lastName,
        phone: this.phone,
        email: this.email,
        password: this.password,
        password_confirmation: this.passwordConfirm,
      };
      AuthService.registerUser(payload)
        .then(() => this.$router.push("/dashboard"))
        .catch((error) => (this.error = getError(error)));
    },
  },
};
</script>
